import { Fragment } from 'react'

import { Text, View } from '@react-pdf/renderer'

import { styles } from '../styles/styles'
import type { ReportExportDetailsI } from '../types/types'
import { HiveWatchLogo } from './HiveWatchLogo'

interface FooterIProps {
  exportDetails: ReportExportDetailsI
}

export const Footer = ({ exportDetails }: FooterIProps) => {
  const exportedAt = [
    'Exported at',
    exportDetails.dateExported,
    exportDetails.timeExported,
    exportDetails.timeZone,
  ]
    .filter(Boolean)
    .join(' ')

  const metadataFields = [exportedAt, exportDetails.username].filter(Boolean)

  return (
    <View fixed style={styles.footer}>
      <View style={styles.footerContent}>
        {metadataFields.map((field, index) => (
          <Fragment key={index}>
            {index > 0 && <Text style={styles.footerSeparator}>/</Text>}
            <Text>{field}</Text>
          </Fragment>
        ))}
      </View>
      <View style={styles.footerBranding}>
        <Text>POWERED BY</Text>
        <HiveWatchLogo />
        <Text
          render={({ pageNumber }) => `${pageNumber}`}
          style={styles.footerPageNumber}
        />
      </View>
    </View>
  )
}
